import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetRepostJobLink(jobId: string) {
  const countryCode = useSiteCountryCode();

  return {
    repostJobLink: `/${countryCode}/jobs/${jobId}/repost-job?new=true`
  };
}
